import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Paper, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
import api from "../../api/axiosInstance"
import AppBarComponent from "../../components/layout/AppbarComponent";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const STATUS_COLORS = {
  finished: "#8BC34A",
  onProgress: "#03A9F4",
  pending: "#FFC107",
};

const STATUS_LABELS = {
  finished: "ซอฟต์แวร์ที่ทำการประเมินเรียบร้อย",
  onProgress: "ซอฟต์แวร์ที่อยู่ระหว่างการประเมิน",
  pending: "ซอฟต์แวร์ที่รอรับการประเมิน",
};

const EstimatePage = () => {
  const [softwares, setSoftwares] = useState([]);
  const navigate = useNavigate();

  const fetchSoftwares = async () => {
    try {
      const res = await api.get(`api/software`);
      // ✅ keep only onProgress + pending
      const filtered = res.data.filter(
        (sw) => sw.status === "onProgress" || sw.status === "pending"
      );
      setSoftwares(filtered);
    } catch (err) {
      console.error("Failed to fetch software data", err);
      toast.error("โหลดข้อมูลไม่สำเร็จ");
    }
  };

  useEffect(() => {
    fetchSoftwares();
  }, []);

  const columns = [
    { field: "software_id", headerName: "ID", flex: 0.4 },
    { field: "software_name", headerName: "ชื่อซอฟต์แวร์", flex: 1 },
    { field: "owner", headerName: "เจ้าของ", flex: 0.5 },
    { field: "created_at", headerName: "วันที่เพิ่มเข้าระบบ", flex: 0.5 },
    {field: "dev_manhours", headerName: "ค่าความพยายาม (man-hours)", flex: 0.8},
    {field: "cost", headerName: "ราคา (บาท)", flex: 0.5},
    {field: "duration", headerName: "ระยะเวลา (วัน)", flex: 0.5},
    {
      field: "status",
      headerName: "สถานะ",
      flex: 1,
      renderCell: (params) => (
        <Box
          sx={{
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            color: "#fff",
            backgroundColor: STATUS_COLORS[params.value] || "#888",
            textAlign: "center",
            width: "100%",
          }}
        >
          {STATUS_LABELS[params.value] || params.value}
        </Box>
      ),
    },
    {
      field: "actions",
      headerName: "การประเมิน",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/software/edit/${params.row.software_id}`);
          }}
        >
          ประเมิน
        </Button>
      ),
    },
  ];

  return (
    <>
      <CssBaseline />
      <AppBarComponent />

      <Box sx={{ p: 2, backgroundColor: "#DFF6F0", minHeight: "100vh" }}>
        <Paper
          sx={{
            width: "95%",
            margin: "0 auto",
            p: 3,
            borderRadius: 2.5,
            backgroundColor: "#E6F7F4",
          }}
        >
          <Typography variant="h5" mb={3} sx={{ fontWeight: "bold" }}>
            รายการซอฟต์แวร์ที่ต้องประเมิน
          </Typography>

          {/* DataGrid Table */}
          <Box sx={{ height: 500, backgroundColor: "#fff", borderRadius: 2 }}>
            <DataGrid
              rows={softwares}
              columns={columns}
              getRowId={(row) => row.software_id}
              pageSize={5}
              rowsPerPageOptions={[5, 10, 20]}
              // onRowClick={handleRowClick}
              sx={{
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f0f0f0",
                  fontWeight: "bold",
                },
              }}
            />
          </Box>
        </Paper>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default EstimatePage;
